import { StarbaseEntity, Serializable } from 'starbase-launcher';
import { LUArmy } from './luArmy';
import { IColumnModel, ColumnModel } from 'table-editor';
import { onlyUniqueByKey } from 'starbase-launcher';
import { of } from 'rxjs';
import { map } from 'rxjs/operators';

export class Army extends StarbaseEntity implements Serializable<Army> {
    public army: LUArmy;
    public armyId: number;
    public regionalName: string;
    public armyName: string;

    constructor() {
        super();
    }

    public static ArmyColumnData(armyNames: LUArmy[], editable: boolean = false): IColumnModel[] {
        armyNames = onlyUniqueByKey(armyNames, 'uid'); // unique entries only
        return [
            new ColumnModel('UID', 'uid', 'UID', false, 'number', false, false, 10, false, null, null),
            new ColumnModel('Army', 'army', 'Army', editable, 'dropdown', true, true, 50, false, armyNames, 'armyName', null, null, null, null, false),
            new ColumnModel('Regional Name', 'regionalName', 'RegionalName', editable, 'string', false, false, 100, true),
            new ColumnModel('Created By', 'createdByUser', 'CreatedByUser', false, 'string', false, false, 100, false),
            new ColumnModel('Created Date/Time', 'createdDateTime', 'CreatedDateTime', false, 'date', false, true, 100, false)
        ];
    }
    public static CreateArmyColumnData(armies: LUArmy[]): IColumnModel[] {
        armies = onlyUniqueByKey(armies, 'uid'); // unique entries only
        return [
            new ColumnModel('Army', 'army', 'Army', true, 'dropdown', false, false, 50, false, armies, 'armyName', null, null, null, null, false),
            new ColumnModel('Regional Name', 'regionalName', 'RegionalName', true, 'string', false, false, 100, true)
        ];
    }

    public static setupArmyCollection(collection: Army[]): void {
        of(collection).pipe(
            map((a: Army[]) =>
                a.map((k: Army) => {
                    k.armyName = k.army.armyName;
                    k = new Army().deserialize(k);
                    k.army = new LUArmy().deserialize(k.army);
                })
            )
        ).subscribe();
    }

    deserialize(input) {
        const a = Object.assign(new Army(), input);
        a.selected = (input.selected) ? input.selected : false;
        a.armyName = a.fullName();
        return a;
    }

    public fullName(): string {
        return this.army.armyName + ' - ' + this.regionalName;
    }
}
